import styled, { css, keyframes } from 'styled-components';
import colours from 'theme/atoms/colours';
import * as Text from 'theme/components/Text.style';

export const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const backdropOverlayStyles = css`
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100dvh;
  z-index: 80;
  background-color: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  display: flex;
  align-items: flex-end;
  justify-content: center;
`;

export const NoteCaptureCard = styled.div<{ $inline?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${colours.shade[0]};
  border-radius: 40px;
  box-shadow: ${({ $inline }) =>
    $inline
      ? '0 0 0 0.5px rgba(0, 0, 0, 0.03), 0 20px 80px -15px rgba(0, 29, 37, 0.1)'
      : '0px 0px 0px 1px rgba(0, 0, 0, 0.02), 0px 0px 80px -10px rgba(0, 0, 0, 0.3), 0px 0px 80px -10px rgba(0, 0, 0, 0.3)'};
  overflow: hidden;
  width: 100%;
  max-width: ${({ $inline }) => ($inline ? '100%' : '382px')};
`;

export const ConfirmationContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 10px;
  padding: 40px 20px 30px;
  width: 100%;
  box-sizing: border-box;
`;

export const ConfirmationMessage = styled(Text.P2)`
  text-align: center;
  color: ${colours.neutral[500]};
`;

export const ConfirmationButtons = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
`;

export const HiddenFileInput = styled.input.attrs({ type: 'file' })`
  display: none;
`;
